import PropTypes from 'prop-types';
import ChickletHoverActions from './ChickletHoverActions';
import { PRIMARY_STATE, SECONDARY_STATE } from '../types/ChickletHoverStates';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  Buttons: PropTypes.elementType.isRequired,
  children: PropTypes.node,
  onPreview: PropTypes.func.isRequired,
  onRemoveAssociation: PropTypes.func,
  toObjectLabel: PropTypes.node,
  canView: PropTypes.bool.isRequired,
  associatedObjectsIds: PropTypes.array,
  associationDefinitions: PropTypes.array,
  fromObjectTypeId: PropTypes.string,
  objectId: PropTypes.number,
  objectTypeId: PropTypes.string,
  primaryAssociationObjectInfo: PropTypes.shape({
    primaryAssociationObjectId: PropTypes.number,
    primaryAssociationPrimaryDisplayLabel: PropTypes.string
  }),
  fromObjectId: PropTypes.number
};
const ChickletHoverActionsContainer = ({
  Buttons,
  children,
  onPreview,
  onRemoveAssociation,
  toObjectLabel,
  canView,
  // only used for flexible-associations
  associatedObjectsIds,
  associationDefinitions = [],
  fromObjectTypeId,
  objectTypeId,
  primaryAssociationObjectInfo = {},
  objectId,
  fromObjectId
}) => {
  const currentState = objectId === primaryAssociationObjectInfo.primaryAssociationObjectId ? PRIMARY_STATE : SECONDARY_STATE;
  const buttonsProps = {
    onPreview,
    onRemoveAssociation,
    toObjectLabel,
    canView,
    // only used for flexible-associations
    associatedObjectsIds,
    associationDefinitions,
    fromObjectTypeId,
    objectTypeId,
    objectId,
    currentState,
    primaryAssociationObjectId: primaryAssociationObjectInfo.primaryAssociationObjectId,
    fromObjectId
  };
  return /*#__PURE__*/_jsx(ChickletHoverActions, {
    Buttons: Buttons,
    buttonsProps: buttonsProps,
    children: children
  });
};
ChickletHoverActionsContainer.propTypes = propTypes;
export default ChickletHoverActionsContainer;